import { useTranslation } from 'next-i18next'
import { LocationUnit } from 'state/ducks/locationUnit/models'
import { Space } from 'state/ducks/space/models.new'

// function spaceLabels(space, availableFrom, availableTo) {
function useSpaceLabels(space) {
  const { t } = useTranslation()

  return [
    {
      className: 'hasWifi',
      isPermit: space.has_wifi,
      text: t('SPACES.SEARCH.FILTER.HAS_WIFI'),
      icon: '/label_has_wifi_icon_blue.svg',
      meta: t('META.HAS_WIFI_ICON'),
    },
    {
      className: 'hasCharge',
      isPermit: space.has_charge,
      text: t('SPACES.SEARCH.FILTER.HAS_CHARGE'),
      icon: '/label_has_charge_icon_blue.svg',
      meta: t('META.HAS_CHARGE_ICON'),
    },
    {
      className: 'availableInEnglish',
      isPermit: space.available_in_english,
      text: t('SPACES.SEARCH.FILTER.AVAILABLE_IN_ENGLISH'),
      icon: '/label_available_in_english_icon_blue.svg',
      meta: t('META.AVAILABLE_IN_ENGLISH_ICON'),
    },
    {
      className: 'noSmoking',
      isPermit: space.no_smoking,
      text: t('SPACES.SEARCH.FILTER.NO_SMOKING'),
      icon: '/label_no_smoking_icon_blue.svg',
      meta: t('META.NO_SMOKING_ICON'),
    },
    {
      className: 'hasElevator',
      isPermit: space.has_elevator,
      text: t('SPACES.SEARCH.FILTER.HAS_ELEVATOR'),
      icon: '/label_has_elevator_icon_blue.svg',
      meta: t('META.HAS_ELEVATOR_ICON'),
    },
    {
      className: 'canBookOnTheDay',
      isPermit: space.can_book_on_the_day,
      text: t('SPACES.SEARCH.FILTER.CAN_BOOK_ON_THE_DAY'),
      icon: '/basic_information_label_can_book_on_the_day_icon.svg',
      meta: t('META.CAN_BOOK_ON_THE_DAY_ICON'),
    },
    {
      className: 'open24Hours',
      isPermit: space.available_24_hour,
      text: t('SPACES.SEARCH.FILTER.OPEN_24_HOURS'),
      icon: '/open_24_hours_icon_blue.svg',
      meta: t('META.OPEN_24_HOURS_ICON'),
    },
  ]
}

function useBasicInformationSpaceLabels(space) {
  const { t } = useTranslation()

  return [
    {
      className: 'distance',
      isPermit: true,
      text: t('SPACE_DETAIL.SECTION.BASIC_INFORMATION.WALKING_DISTANCE', {
        detailed_place: space.station_name_1,
        distance_from_station: space.distance_from_station_1,
      }),
      icon: '/basic_information_label_distance_icon.svg',
      meta: t('META.INFORMATION_DISTANCE_ICON'),
    },
    {
      className: 'canBookOnTheDay',
      isPermit: space.can_book_on_the_day,
      text: t('SPACE_DETAIL.SECTION.BASIC_INFORMATION.CAN_BOOK_ON_THE_DAY'),
      icon: '/basic_information_label_can_book_on_the_day_icon.svg',
      meta: t('META.CAN_BOOK_ON_THE_DAY_ICON'),
    },
    {
      className: 'onSiteSale',
      isPermit: space.accept_on_site_payment,
      text: t('SPACE_DETAIL.SECTION.BASIC_INFORMATION.ON_SITE_SALE'),
      icon: '/basic_information_on_site_sale_icon.svg',
      meta: t('META.ON_SITE_SALE_ICON'),
    },
    {
      className: 'hasElevator',
      isPermit: space.has_elevator,
      text: t('SPACE_DETAIL.SECTION.BASIC_INFORMATION.HAS_ELEVATOR'),
      icon: '/basic_information_label_has_elevator_icon.svg',
      meta: t('META.HAS_ELEVATOR_ICON'),
    },
    {
      className: 'hasWifi',
      isPermit: space.has_wifi,
      text: t('SPACE_DETAIL.SECTION.BASIC_INFORMATION.HAS_WIFI'),
      icon: '/basic_information_label_has_wifi_icon.svg',
      meta: t('META.HAS_WIFI_ICON'),
    },
    {
      className: 'hasCharge',
      isPermit: space.has_charge,
      text: t('SPACE_DETAIL.SECTION.BASIC_INFORMATION.HAS_CHARGE'),
      icon: '/basic_information_label_has_charge_icon.svg',
      meta: t('META.HAS_CHARGE_ICON'),
    },
    {
      className: 'noSmoking',
      isPermit: space.no_smoking,
      text: t('SPACE_DETAIL.SECTION.BASIC_INFORMATION.NO_SMOKING'),
      icon: '/basic_information_no_smoking_icon.svg',
      meta: t('META.NO_SMOKING_ICON'),
    },
    // {
    //   className: 'hasBysicle',
    //   isPermit: space.no_smoking,
    //   text: t('SPACE_DETAIL.SECTION.BASIC_INFORMATION.HAS_BYSICLE'),
    //   icon: '/basic_information_label_bysicle_ok_icon.svg',
    //   meta: t('META.HAS_BYSICLE_ICON'),
    // },
    {
      className: 'availableInEnglish',
      isPermit: space.available_in_english,
      text: t('SPACE_DETAIL.SECTION.BASIC_INFORMATION.AVAILABLE_IN_ENGLISH'),
      icon: '/basic_information_label_available_in_english_icon.svg',
      meta: t('META.AVAILABLE_IN_ENGLISH_ICON'),
    },
  ]
}

function useUnitLabels(locationUnit: LocationUnit) {
  const { t } = useTranslation()

  if (!locationUnit.basicInfo) {
    return []
  }

  return [
    {
      className: 'hasWifi',
      isPermit: locationUnit.basicInfo.hasWifi,
      text: t('SPACES.SEARCH.FILTER.HAS_WIFI'),
      icon: '/label_has_wifi_icon_blue.svg',
      meta: t('META.HAS_WIFI_ICON'),
    },
    {
      className: 'hasCharge',
      isPermit: locationUnit.basicInfo.hasCharge,
      text: t('SPACES.SEARCH.FILTER.HAS_CHARGE'),
      icon: '/label_has_charge_icon_blue.svg',
      meta: t('META.HAS_CHARGE_ICON'),
    },
    {
      className: 'availableInEnglish',
      isPermit: locationUnit.basicInfo.availableInEnglish,
      text: t('SPACES.SEARCH.FILTER.AVAILABLE_IN_ENGLISH'),
      icon: '/label_available_in_english_icon_blue.svg',
      meta: t('META.AVAILABLE_IN_ENGLISH_ICON'),
    },
    {
      className: 'noSmoking',
      isPermit: locationUnit.basicInfo.noSmoking,
      text: t('SPACES.SEARCH.FILTER.NO_SMOKING'),
      icon: '/label_no_smoking_icon_blue.svg',
      meta: t('META.NO_SMOKING_ICON'),
    },
    {
      className: 'hasElevator',
      isPermit: locationUnit.basicInfo.hasElevator,
      text: t('SPACES.SEARCH.FILTER.HAS_ELEVATOR'),
      icon: '/label_has_elevator_icon_blue.svg',
      meta: t('META.HAS_ELEVATOR_ICON'),
    },
    {
      className: 'canBookOnTheDay',
      isPermit: locationUnit.basicInfo.canBookOnTheDay,
      text: t('SPACES.SEARCH.FILTER.CAN_BOOK_ON_THE_DAY'),
      icon: '/basic_information_label_can_book_on_the_day_icon.svg',
      meta: t('META.CAN_BOOK_ON_THE_DAY_ICON'),
    },
    {
      className: 'open24Hours',
      isPermit: locationUnit.basicInfo.available24Hour,
      text: t('SPACES.SEARCH.FILTER.OPEN_24_HOURS'),
      icon: '/open_24_hours_icon_blue.svg',
      meta: t('META.OPEN_24_HOURS_ICON'),
    },
  ]
}

const usePudoSpaceTags = (space: Space) => {
  const { t } = useTranslation()

  return [
    {
      isPermit: true,
      text: t('LOCKER.LABEL.LOCKER_DESCRIPTION'),
      icon: '/locker_outline_icon.png',
      meta: t('META.LOCKER_DESCRIPTION_ICON'),
    },
    {
      className: 'hasWifi',
      isPermit: space.features.has_wifi,
      text: t('SPACES.SEARCH.FILTER.HAS_WIFI'),
      icon: '/label_has_wifi_icon_blue.svg',
      meta: t('META.HAS_WIFI_ICON'),
    },
    {
      className: 'hasCharge',
      isPermit: space.features.has_charge_spot,
      text: t('SPACES.SEARCH.FILTER.HAS_CHARGE'),
      icon: '/label_has_charge_icon_blue.svg',
      meta: t('META.HAS_CHARGE_ICON'),
    },
    {
      className: 'availableInEnglish',
      isPermit: space.features.english_supported,
      text: t('SPACES.SEARCH.FILTER.AVAILABLE_IN_ENGLISH'),
      icon: '/label_available_in_english_icon_blue.svg',
      meta: t('META.AVAILABLE_IN_ENGLISH_ICON'),
    },
    {
      className: 'noSmoking',
      isPermit: space.features.no_smoking,
      text: t('SPACES.SEARCH.FILTER.NO_SMOKING'),
      icon: '/label_no_smoking_icon_blue.svg',
      meta: t('META.NO_SMOKING_ICON'),
    },
    {
      className: 'hasElevator',
      isPermit: space.features.has_elevator,
      text: t('SPACES.SEARCH.FILTER.HAS_ELEVATOR'),
      icon: '/label_has_elevator_icon_blue.svg',
      meta: t('META.HAS_ELEVATOR_ICON'),
    },
    {
      className: 'canBookOnTheDay',
      isPermit: space.can_reserve_same_day,
      text: t('SPACES.SEARCH.FILTER.CAN_BOOK_ON_THE_DAY'),
      icon: '/basic_information_label_can_book_on_the_day_icon.svg',
      meta: t('META.CAN_BOOK_ON_THE_DAY_ICON'),
    },
  ]
}

export { useSpaceLabels, useBasicInformationSpaceLabels, useUnitLabels, usePudoSpaceTags }
